export default class Payment {
  constructor({ onSuccess, onFailure }) {
    this.onFailure = onFailure;
    this.onSuccess = onSuccess;

    // window.TwoCoInlineCart.events.subscribe("payment:finalized", onSuccess);
  }

  setProduct(product) {
    window.TwoCoInlineCart.setup.setMode("DYNAMIC");
    window.TwoCoInlineCart.products.add(product);
    return this;
  }
  checkout({ extranalRef, redirectUrl, email }) {
    // window.TwoCoInlineCart.events.subscribe("cart:opened", this.onSuccess);
    // window.TwoCoInlineCart.billing.setCountry('IN');
    // window.TwoCoInlineCart.billing.setName('John Doe');

    // window.TwoCoInlineCart.billing.setCity('Kochi');
    // window.TwoCoInlineCart.billing.setState('Kerala');
    // window.TwoCoInlineCart.billing.setZip(673645);

    // window.TwoCoInlineCart.cart.setTest(true);
    if (email) window.TwoCoInlineCart.billing.setEmail(email);
    window.TwoCoInlineCart.cart.setCurrency("USD");
    window.TwoCoInlineCart.cart.setReturnMethod({
      url: redirectUrl,
      type: "redirect"
    });
    window.TwoCoInlineCart.cart.setOrderExternalRef(extranalRef);
    window.TwoCoInlineCart.cart.checkout();
  }
}
